export type YesNo = 'yes' | 'no';

export type SpecialStatusOutcome = 'eligible' | 'ineligible' | 'skipped' | '';

export type WidowSpouseLost = 'death' | 'divorce' | 'no' | '';

export type SchoolType =
  | 'university'
  | 'junior_college'
  | 'high_school'
  | 'vocational'
  | 'specialized'
  | 'other'
  | '';

export type SpecialStatusStep =
  | 'singleParentIntro'
  | 'singleParentPickChild'
  | 'singleParentConfirmChild'
  | 'singleParentClaimedByOther'
  | 'singleParentResult'
  | 'widowIntro'
  | 'widowLossStatus'
  | 'widowRemarried'
  | 'widowResult'
  | 'workingStudentIntro'
  | 'workingStudentEnrolled'
  | 'workingStudentSchoolType'
  | 'workingStudentSalaryOnly'
  | 'workingStudentSalaryRevenue'
  | 'workingStudentNonEmployment'
  | 'workingStudentNonEmploymentAmount'
  | 'workingStudentResult'
  | 'disabilityWsChangedDuringYear'
  | 'disabilityWsChangeDate'
  | 'review';

export type SingleParentCandidate = {
  empFamilyId: number;
  fullName: string;
  relationship: 'child' | 'grandchild';
  sharedLivelihood: boolean;
  claimedByOtherIncome: boolean;
};

/** One completed Q&A pass for a child in the multi-child single-parent loop. */
export type SingleParentChildHistoryEntry = {
  candidate: SingleParentCandidate;
  confirmed: YesNo;
  claimedByOther?: YesNo;
};

export type SpecialStatusSnapshot = {
  singleParentChildEmpFamilyId: number | null;
  singleParentChildRelationship: string;
  singleParentChildConfirmed: YesNo | '';
  singleParentClaimedByOther: YesNo | '';
  singleParentOutcome: SpecialStatusOutcome;
  widowSpouseLost: WidowSpouseLost;
  widowCurrentlyRemarried: YesNo | '';
  widowOutcome: SpecialStatusOutcome;
  workingStudentEnrolled: YesNo | '';
  workingStudentSchoolType: SchoolType;
  workingStudentSalaryOnly: YesNo | '';
  workingStudentSalaryRevenue: string;
  workingStudentHasNonEmploymentIncome: YesNo | '';
  workingStudentNonEmploymentIncome: string;
  workingStudentOutcome: SpecialStatusOutcome;
  disabilityWsChangedDuringYear: YesNo | '';
  /** YYYY-MM-DD when changed during year */
  disabilityWsChangeDate: string;
};

export const SPECIAL_STATUS_STEP_ORDER: SpecialStatusStep[] = [
  'singleParentIntro',
  'singleParentPickChild',
  'singleParentConfirmChild',
  'singleParentClaimedByOther',
  'singleParentResult',
  'widowIntro',
  'widowLossStatus',
  'widowRemarried',
  'widowResult',
  'workingStudentIntro',
  'workingStudentEnrolled',
  'workingStudentSchoolType',
  'workingStudentSalaryOnly',
  'workingStudentSalaryRevenue',
  'workingStudentNonEmployment',
  'workingStudentNonEmploymentAmount',
  'workingStudentResult',
  'disabilityWsChangedDuringYear',
  'disabilityWsChangeDate',
  'review',
];

export function emptySpecialStatus(): SpecialStatusSnapshot {
  return {
    singleParentChildEmpFamilyId: null,
    singleParentChildRelationship: '',
    singleParentChildConfirmed: '',
    singleParentClaimedByOther: '',
    singleParentOutcome: '',
    widowSpouseLost: '',
    widowCurrentlyRemarried: '',
    widowOutcome: '',
    workingStudentEnrolled: '',
    workingStudentSchoolType: '',
    workingStudentSalaryOnly: '',
    workingStudentSalaryRevenue: '',
    workingStudentHasNonEmploymentIncome: '',
    workingStudentNonEmploymentIncome: '',
    workingStudentOutcome: '',
    disabilityWsChangedDuringYear: '',
    disabilityWsChangeDate: '',
  };
}

export const SCHOOL_TYPE_OPTIONS: SchoolType[] = [
  'university',
  'junior_college',
  'high_school',
  'vocational',
  'specialized',
  'other',
];

export const WIDOW_LOSS_OPTIONS: Exclude<WidowSpouseLost, ''>[] = ['death', 'divorce', 'no'];
